import { useCallback, useEffect, useState } from 'react';
import adminService from '../../api/adminService';
import { useNotifications } from '../../context/NotificationContext';
import Field from '../common/Field';
import LoadingSpinner from '../common/LoadingSpinner';

const EMPTY = { name: '', description: '', iconUrl: '', active: true };

export default function ServiceManagement() {
  const notify = useNotifications();
  const [types, setTypes] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const load = useCallback(
    () => adminService.listTechnicianTypes().then(setTypes).catch((e) => notify.apiError(e)),
    [notify]
  );
  useEffect(() => { load(); }, [load]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (editing) {
        await adminService.updateTechnicianType(editing, form);
        notify.success('Category updated');
      } else {
        await adminService.createTechnicianType(form);
        notify.success('Category created');
      }
      setForm(EMPTY); setEditing(null);
      load();
    } catch (err) {
      notify.apiError(err);
    } finally {
      setBusy(false);
    }
  };

  const edit = (t) => { setEditing(t.id); setForm({ name: t.name, description: t.description || '', iconUrl: t.iconUrl || '', active: t.active }); };
  const remove = async (t) => {
    if (!window.confirm(`Remove "${t.name}"?`)) return;
    try { await adminService.deleteTechnicianType(t.id); notify.success('Removed'); load(); }
    catch (e) { notify.apiError(e); }
  };
  const toggleActive = async (t) => {
    try { await adminService.updateTechnicianType(t.id, { name: t.name, active: !t.active }); load(); }
    catch (e) { notify.apiError(e); }
  };

  if (!types) return <div className="page"><div className="container"><LoadingSpinner /></div></div>;

  return (
    <div className="page">
      <div className="container split">
        <form className="card pad" onSubmit={save}>
          <h3 style={{ marginBottom: '.75rem' }}>{editing ? 'Edit category' : 'New category'}</h3>
          <Field label="Name" required value={form.name} onChange={set('name')} />
          <Field as="textarea" label="Description" value={form.description} onChange={set('description')} />
          <Field label="Icon URL (optional)" value={form.iconUrl} onChange={set('iconUrl')} />
          <button className="btn block" disabled={busy}>{busy ? 'Saving…' : editing ? 'Save' : 'Create'}</button>
          {editing && (
            <button type="button" className="btn ghost block" style={{ marginTop: '.5rem' }}
              onClick={() => { setEditing(null); setForm(EMPTY); }}>Cancel</button>
          )}
        </form>

        <div className="stack">
          <h2>Trade categories</h2>
          {types.map((t) => (
            <div key={t.id} className="card pad spread">
              <div>
                <strong>{t.name}</strong> {!t.active && <span className="badge gray">inactive</span>}
                <p className="muted" style={{ fontSize: '.85rem' }}>
                  {t.description || '—'} · {t.technicianCount} technician{t.technicianCount === 1 ? '' : 's'}
                </p>
              </div>
              <div className="row" style={{ gap: '.4rem' }}>
                <button className="btn ghost sm" onClick={() => toggleActive(t)}>{t.active ? 'Disable' : 'Enable'}</button>
                <button className="btn ghost sm" onClick={() => edit(t)}>Edit</button>
                <button className="btn danger sm" onClick={() => remove(t)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
